import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY } from 'rxjs';
import { ErrorService } from 'src/app/core/errors/error.service';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.css'],
  standalone: true,
  imports: [FormsModule],
})
export class ErrorDialogComponent {

  userFeedback: string = "";

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; status?: number, request?: any, context?: string },
    private errorService: ErrorService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  sendFeedback(): void {
    this.errorService.sendErrorNotification(this.userFeedback, this.data.request, this.data.context)
    .pipe(
      catchError((notificationError) => {
        console.warn('Failed to send error notification:', notificationError);
        return EMPTY;
      })
    ).subscribe();
    
    this.close();
  }
}
